import {type AriaButtonOptions, useButton} from 'react-aria'
import {ButtonContext, useContextProps} from 'react-aria-components'

import style from './PrimaryButton.module.scss'

interface Props extends AriaButtonOptions<'button'> {
  size?: 'xl' | 'lg' | 'md' | 'sm'
  className?: string
  isPending?: boolean
  showPendingIndicator?: boolean
  ref?: Ref<HTMLButtonElement>
}

const PrimaryButton = deepMemo(function PrimaryButton({
  ref,
  showPendingIndicator = true,
  ...props
}: PropsWithChildren<Props>) {
  ;[props, ref] = useContextProps(
    {
      ...props,

      isDisabled: props.isDisabled ?? props.isPending,
    },
    // @ts-expect-error -- TODO: fix this
    ref,
    ButtonContext,
  )

  const {buttonProps} = useButton(props, ref)

  const defaultClassName = clsx(
    style.Button,
    style.Rounded,
    (() => {
      switch (props.size) {
        case 'xl':
          return style.ExtraLarge
        case 'lg':
          return style.Large
        case 'md':
          return style.Medium
        case 'sm':
          return style.Small
        case undefined:
          return style.Large
      }
    })(),
  )

  return (
    <button
      {...buttonProps}
      ref={ref}
      className={clsx(defaultClassName, props.className)}
      aria-disabled={props.isDisabled}
      disabled={false}
      data-pending={props.isPending}
    >
      {showPendingIndicator && props.isPending && (
        <div className={clsx(style.Loader, props.size === 'sm' && style.Small)} />
      )}
      {props.children}
    </button>
  )
})

export default PrimaryButton
